/**
 * Flaggle board helpers — pure. The server sends the revealed flag as a string
 * of palette digits ("-" = still hidden), w×h cells, row-major.
 */

export type Rgb = [number, number, number];

/** Cells hidden before and known now — the ones a board animates in. */
export function freshCells(prev: string | null, next: string): number[] {
  if (prev === null || prev.length !== next.length) return [];
  const out: number[] = [];
  for (let i = 0; i < next.length; i++) if (prev[i] === "-" && next[i] !== "-") out.push(i);
  return out;
}

/** Stable pseudo-random 0..1 per cell (texture, jitter) — same on every render and phone. */
export function hash01(i: number, salt = 0): number {
  let x = (i + 1) * 374761393 + salt * 668265263;
  x = (x ^ (x >>> 13)) * 1274126177;
  x ^= x >>> 16;
  return (x >>> 0) / 4294967296;
}

export function css([r, g, b]: Rgb, alpha = 1): string {
  return alpha >= 1 ? `rgb(${r},${g},${b})` : `rgba(${r},${g},${b},${alpha})`;
}

/** Lighten (amt > 0) or darken (amt < 0) a colour by a fraction toward white/black. */
export function shade([r, g, b]: Rgb, amt: number): Rgb {
  const t = amt >= 0 ? 255 : 0;
  const k = Math.abs(amt);
  return [Math.round(r + (t - r) * k), Math.round(g + (t - g) * k), Math.round(b + (t - b) * k)];
}

export const clamp01 = (x: number) => (x < 0 ? 0 : x > 1 ? 1 : x);
export const easeOut = (t: number) => 1 - (1 - t) * (1 - t);
